import type { PhotoEffectSliderMode } from '../types/photo-effect-slider-mode'

/** Track fill geometry, in percent of the track: centre-origin for symmetric, left-origin for percent. */
export function computeFill(mode: PhotoEffectSliderMode, value: number, min: number, max: number) {
  const span = max - min

  if (span <= 0) {
    return { leftPct: 0, widthPct: 0 }
  }

  const valuePct = ((value - min) / span) * 100

  if (mode === 'percent') {
    return { leftPct: 0, widthPct: valuePct }
  }

  const centerPct = ((0 - min) / span) * 100

  if (value > 0) {
    return { leftPct: centerPct, widthPct: valuePct - centerPct }
  }

  if (value < 0) {
    return { leftPct: valuePct, widthPct: centerPct - valuePct }
  }

  return { leftPct: centerPct, widthPct: 0 }
}
